import React from "react";
import { ViewMoreInstantOrderInfo } from "../../../pages";

const ViewMoreInstantOrderInfoContainer = ({ singleItem, closeModal }) => {
  return (
    <ViewMoreInstantOrderInfo singleItem={singleItem} closeModal={closeModal} />
  );
};

export default ViewMoreInstantOrderInfoContainer;
